import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type {
  CpeautorapportState,
  CpeAutoRapportListState,
  singleElementState,
} from "@/types/store";

const CpeAutoRapportListState: CpeAutoRapportListState = {
  data: [],
  error: null,
  loading: false,
  count: 0,
};

const singleElementState: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const cpeAutoState: CpeautorapportState = {
  cpeautorapports: CpeAutoRapportListState,
  cpeautorapport: singleElementState,
  cpeautorapportshistory: CpeAutoRapportListState,
};

export const CpeAutoRapportModule = {
  namespaced: true,
  state: cpeAutoState,
  actions,
  mutations,
  getters,
};
